const NewCoursesSectionlang = {
    ar: {
        title: "الدورات التدريبية الجديدة",
        description: "شاهد الدورات التدريبية الجديدة التي تمت إضافتها.",
        noCoursesMessage: "لا يوجد دورات تدريبية تمت اضافتها ..",
        buttonText: "اشتر الآن",
        likedText: "أضف إلى المفضلة",
        price: "دينار",
      },
      en: {
        title: "New Training Courses",
        description: "Check out the new training courses that have been added.",
        noCoursesMessage: "No new training courses added yet.",
        buttonText: "Buy Now",
        likedText: "Add to Favorites",
        price: "Dinar",
      },
  };
  
  export default NewCoursesSectionlang;
  